<template>

  <Section 
  background="#e8e5de"
  :class="sectionTotal === sectionIndex + 1 ? 'bottom-reset' : ''"
  >
    <Container>

      <FadeIn class="mx-auto max-w-2xl">
        <h2 v-if="content.title" class="text-section-title">{{ content.title }}</h2>
        <div class="mt-10 relative">
          <div class="relative">
            <div v-for="(faq, index) in content.faqs" 
                 class="border-2 border-[#d7d4cd] hover:border-[#5a6ded] transition bg-white rounded-xl mb-4 duration-200" 
                 :class="{ 'hidden': !showAllFaqs && index >= 5 }"
                 :key="index">
              <button 
                @click="togglePanel(index)" 
                class="pointer py-4 md:py-6 w-full text-left"
                :aria-expanded="activePanel === index"
                :aria-controls="`faq-content-${index}`"
                :aria-label="`Toggle FAQ: ${faq.faq_item_id.question}`"
              >
                <div class="flex w-full items-start justify-between text-left items-center">
                  <div class="text-base font-semibold leading-6 w-[calc(100%-4rem)] lg:text-lg px-4">
                    {{ faq.faq_item_id.question }}
                  </div>
                  <div class="mr-4 bg-[#5a6ded] border-2 border-[#3645d0] rounded w-8 h-8 flex items-center justify-center">
                    <Icon name="ph:caret-down" v-if="activePanel !== index" class="h-6 w-6 text-[#fff]" />
                    <Icon name="ph:caret-up" v-else class="h-6 w-6 text-[#fff]" />
                  </div>
                </div>
              </button>
              <div 
                v-show="activePanel === index" 
                class="prose"
                :id="`faq-content-${index}`"
                role="region"
                :aria-labelledby="`faq-button-${index}`"
              >
                <div class="text-base px-4 faq__a" 
                v-interpolation 
                v-html="useSanitize(faq.faq_item_id.answer, currentLocale)"
                ></div>
              </div>
            </div>
            <!-- <div v-if="!showAllFaqs && content.faqs.length > 5" class="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-[#e8e5de] via-[#e8e5decc] to-transparent pointer-events-none"></div> -->
          </div>
          <div v-if="content.faqs.length > 5" class="text-center mt-6">
            <button
              @click="showAllFaqs = !showAllFaqs"
              class="rounded-md transition bg-transparent hover:bg-[rgba(0,0,0,0.03)] px-4 py-2.5 text-sm font-semibold text-[#5a6ded] focus:outline-none inline-flex items-center gap-2"
            >
              {{ showAllFaqs ? 'Show less' : 'See all' }}
              <Icon :name="showAllFaqs ? 'ph:caret-up' : 'ph:caret-down'" class="h-5 w-5" />
            </button>
          </div>
        </div>
      </FadeIn>

    </Container>
  </Section>
</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
  sectionTotal: {
    type: Number,
    default: 0
  },
  sectionIndex: {
    type: Number,
    default: 0
  }
})

const activePanel = ref(999)
const showAllFaqs = ref(false)

const togglePanel = index => {
  const activeIndex = activePanel.value
  if (index === activeIndex) {
    activePanel.value = 999
  } else {
    activePanel.value = index
  }
}

const route = useRoute()
const currentLocale = computed(() => {
  return route.path.startsWith('/nz') ? 'nz' : 'au'
})

// Add FAQ Schema Markup
if (props.content?.faqs?.length > 0) {
  const schemaItems = [
    defineWebPage({
      '@type': 'FAQPage',
    }),
    ...props.content.faqs.map(faq => 
      defineQuestion({
        name: faq.faq_item_id.question,
        acceptedAnswer: faq.faq_item_id.answer
      })
    )
  ]
  
  useSchemaOrg(schemaItems)
}
</script>